import axios from 'axios';
import { LoginReqest, LoginStatus } from '../../../common/dist/common';
import { httpStatusToBoolean, toData } from './base';

export function login(param: LoginReqest) {
  return toData<LoginStatus>(axios.post('/api/auth', param));
}

export function logout() {
  return httpStatusToBoolean(axios.delete('/api/auth'));
}

export function check() {
  return toData<LoginStatus>(axios.get('/api/auth'));
}

export default {
  login,
  check,
  logout,
};
